import { Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { DateRecord } from "../../model/data/DateRecord";

export const AnniversaryDisplayRecord = Record({
  // Normal properties of Event
  id: null,
  itemLabel: null,
  anniversaryIcon: "markerOther",
  anniversaryLabel: "Anniversary",
  age: null,
  color: null,
  // Display extensions
  date: DateRecord()
});

const data = {
  objects: {
    startDate: "DateRecord"
  }
};
createFromJS.registerCallback(
  "AnniversaryDisplayRecord",
  createFromJS.createNestedCallback(AnniversaryDisplayRecord, data)
);
